import { getDeviceConfiguration } from '../configuration/getDeviceConfiguration';
import { getPersonalListType } from '../configuration/utils';

import { prefetchPersonalLineupQuery } from './queries';

export function prefetchPersonalLineup() {
  const configuration = getDeviceConfiguration();

  if (!configuration) {
    return Promise.resolve();
  }

  const listType = getPersonalListType(configuration);

  if (!listType) {
    return Promise.resolve();
  }

  return prefetchPersonalLineupQuery({ listType });
}
